import Vue from 'vue'

export default (state, data) => {
  // Loop over all kinds of entities we received
  for (let type in data.entities) {
    for (let entity in data.entities[type]) {
      if (!Object.hasOwn(state.entities, type)) {
        throw new Error(type + ' not exists in state! please defeine first')
      }
      const oldObj = state.entities[type][entity] || {}
      // Merge the new data in the old object
      const newObj = Object.assign({}, oldObj, data.entities[type][entity])
      // Make sure new entities are also reactive
      Vue.set(state.entities[type], entity, newObj)
    }
  }
}
